import { Pipe, PipeTransform } from '@angular/core';
import { MessageStatuses } from '../message.model';

@Pipe({
  name: 'shMessageStatus',
  standalone: true,
})
export class MessageStatusPipe implements PipeTransform {
  statuses = MESSAGESTATUSES;

  transform(status: MessageStatuses): string {
    return this.getStatusName(status);
  }

  getStatusName(type): string {
    return this.statuses.find((x) => x.value === type).label;
  }
}

export const MESSAGESTATUSES = [
  { value: 0, label: 'Unknown' },
  { value: 1, label: 'Processed' },
  { value: 2, label: 'Manual Action' },
];
